export const CardData = [
  { id: 0, title: "Fancy Product", price: "$40.00 - $80.00", options: true },
  {
    id: 1,
    title: "Special Item",
    ratings: 4,
    striked: "$20.00",
    price: 18.0,
    sale: true,
  },
  { id: 2, title: "Sale Item", striked: "$50.00", price: 25.0, sale: true },
  { id: 3, title: "Popular Item", ratings: 3, price: 40.0 },
  { id: 4, title: "Sale Item", striked: "$50.00", price: 25.0, sale: true },
  { id: 5, title: "Fancy Product", price: "$120.00 - $280.00", options: true },
  {
    id: 6,
    title: "Special Item",
    ratings: 4,
    striked: "$20.00",
    price: 18.0,
    sale: true,
  },
  { id: 7, title: "Popular Item", ratings: 3, price: 40.0 },
];
